import React, { useEffect, useState } from 'react';
import { Button, Header, Icon, Modal, Step, Loader, Dimmer } from 'semantic-ui-react';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';
import './styles.css';

import { post } from '../../../../../../../services/request';
import { HireProposalModalProps } from '../../../types/ModalHireProposalProps';
import { SurtyGeneralInsuranceFormik } from '../Formik/SurtyFormFormik';
import { dangerNotification, successNotification } from '../../../../../../../services/notification';
import { InsurersCodeEnum } from '../../../../../../../enums/insurers-code.enum';
import { hasPermission } from '../../../../../../../components/AuthorizationContainer';
import { ActionEnum } from '../../../../../../../enums/authz-action.enum';
import { FeatureEnum } from '../../../../../../../enums/authz-feature.enum';
import { extractApiErrorMessages } from '../../../../../../../utils/apiErrorHandler';

const SegimobHireProposalModal = ({
  username,
  analysisID,
  maxInstallments,
  nominal_total_premium_amount,
  naturalTentant,
  closeModal,
  setOpen,
  insurer,
  property,
  bondInsurance,
  callback,
  user_id,
  offers,
}: HireProposalModalProps) => {
  const [openHireProposalModal, setOpenHireProposalModal] = useState(false);
  const [flagSubmitFrom, setFlagSubmitFrom] = useState(false);
  const [stepOfHireModal, setStepOfHireModal] = useState('segimobHireProposal');
  const [loading, setLoading] = useState(false);
  const [userCanContract, setUserCanContract] = useState(false);

  useEffect(() => {
    const has = hasPermission(ActionEnum.contract, FeatureEnum.analysis);
    setUserCanContract(has);
  }, []);

  const MySwal = withReactContent(Swal);

  async function handleSubmit(payload: any) {
    try {
      setLoading(true);

      // Validar se uma oferta foi selecionada
      if (!payload.selectedPlan) {
        dangerNotification("Erro", "É necessário selecionar um plano para contratação.", 4000);
        return;
      }

      // Validar dados obrigatórios do proprietário
      if (!payload.owner_data?.name || !payload.owner_data?.public_document_id ||
        !payload.owner_data?.birth_date || !payload.owner_data?.email ||
        !payload.owner_data?.phone) {
        dangerNotification("Erro", "Todos os dados do proprietário são obrigatórios.", 4000);
        return;
      }

      // Validar endereço obrigatório
      if (!payload.owner_data?.zip_code || !payload.owner_data?.street ||
        !payload.owner_data?.number || !payload.owner_data?.district ||
        !payload.owner_data?.city || !payload.owner_data?.state) {
        dangerNotification("Erro", "Todos os dados de endereço são obrigatórios.", 4000);
        return;
      }

      // Validar datas obrigatórias do seguro
      if (!payload.rent_insurance_contract_start_date || !payload.rent_insurance_contract_end_date) {
        dangerNotification("Erro", "As datas de início e fim do contrato do seguro são obrigatórias.", 4000);
        return;
      }

      // Payload otimizado - apenas dados essenciais para Segimob
      const cleanPayload = {
        bondInsuranceAnalysisId: analysisID,
        owner_data: {
          name: payload.owner_data.name,
          public_document_id: payload.owner_data.public_document_id.replace(/\D/g, ''), // Remover máscara
          birth_date: payload.owner_data.birth_date,
          email: payload.owner_data.email,
          phone: payload.owner_data.phone.replace(/\D/g, ''), // Remover máscara
          zip_code: payload.owner_data.zip_code.replace(/\D/g, ''), // Remover máscara
          street: payload.owner_data.street,
          number: payload.owner_data.number,
          district: payload.owner_data.district,
          city: payload.owner_data.city,
          state: payload.owner_data.state,
          complement: payload.owner_data.complement || '',
        },
        selectedPlan: payload.selectedPlan,
        rent_insurance_contract_start_date: payload.rent_insurance_contract_start_date,
        rent_insurance_contract_end_date: payload.rent_insurance_contract_end_date,
        observations: payload.observations || '',
      };

      console.log('Payload limpo para Segimob:', cleanPayload);

      const response = await post("/bond-insurance-analysis/general/hire", cleanPayload);
      console.log('Resposta do backend:', response);

      successNotification("Sucesso", "Contratação iniciada com sucesso. Acompanhe a geração em Gerenciar Apólices.");
      try {
        await callback();
      } catch (callbackErr) {
        console.error('Erro ao atualizar a listagem após contratação:', callbackErr);
      }
      closeModal();
      setOpenHireProposalModal(false);
    } catch (err) {
      dangerNotification("Erro", extractApiErrorMessages(err, 'Erro ao efetuar solicitação.'), 4000);
      console.error('Erro na contratação:', err);
    } finally {
      setLoading(false);
      setFlagSubmitFrom(false);
    }
  };

  const AcceptTerms = () => MySwal.fire({
    title: `Deseja prosseguir com a contratação via <b>Segimob</b> para <b>${insurer?.name}</b> ?`,
    text: "Importante: A contratação será processada via Segimob. Os dados do proprietário são obrigatórios para esta contratação.",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Sim, prosseguir para a contratação!',
    cancelButtonText: 'Cancelar'
  }).then((result) => {
    if (result.isConfirmed) {
      (async () => {
        const { value: checked } = await MySwal.fire({
          title: 'Declaro que: ',
          html:
            `<div class="row"><input id="swal-input1" type="checkbox" class="checkbox"> <label for="swal-input1">Os dados informados para essa contratação estão de acordo e inseridos no Contrato de Locação; Qualquer alteração realizada nesta etapa, poderá afetar o orçamento realizado.</label> </div>
              <div class="row"><input id="swal-input2" type="checkbox" class="checkbox"> <label for="swal-input2">A Cláusula foi inserida no Contrato de Locação. </label> </div>
              <div class="row"><input id="swal-input4" type="checkbox" class="checkbox"> <label for="swal-input4"> Declaro que essa locação não tem débitos em aberto até esta data. </label> </div>`,
          focusConfirm: false,
          confirmButtonText:
            'Ciente e prosseguir',
          denyButtonText: 'Cancelar',
          preConfirm: () => {
            return [
              (document.getElementById('swal-input1') as HTMLInputElement).checked ? 'true' : 'false',
              (document.getElementById('swal-input2') as HTMLInputElement)?.checked ? 'true' : 'false',
              (document.getElementById('swal-input4') as HTMLInputElement)?.checked ? 'true' : 'false',
            ]
          },
        })
        console.log(checked)
        if (Array.isArray(checked) && checked[0] === 'true' && checked[1] === 'true' && checked[2] === 'true') {
          setOpenHireProposalModal(true)
        } else {
          dangerNotification("Aviso", "É necessário aceitar todos os termos para prosseguir.", 4000);
        }
      })()
    }
  });

  return (
    <div style={{ outline: 'none', zIndex: 10, flex: 'auto' }}>
      <Modal
        closeIcon
        open={openHireProposalModal}
        trigger={
          <Button
            disabled={!userCanContract}
            positive
            fluid
          >
            Contratar
          </Button>
        }
        onClose={() => {
          setOpenHireProposalModal(false);
          setFlagSubmitFrom(false);
        }}
        onOpen={() => AcceptTerms()}
      >
        <Header icon="file alternate outline" content={`Contratação Fiança | ${insurer?.name}`} />
        <Modal.Content scrolling>
          <Dimmer active={loading}>
            <Loader indeterminate> Enviando proposta... </Loader>
          </Dimmer>
          {stepOfHireModal === 'segimobHireProposal' && (
            <SurtyGeneralInsuranceFormik
              maxInstallments={maxInstallments}
              nominal_total_premium_amount={nominal_total_premium_amount}
              flagSubmit={flagSubmitFrom}
              callbackSubmit={handleSubmit}
              setFlagSubmit={setFlagSubmitFrom}
              naturalTentant={naturalTentant}
              property={property}
              insurer={insurer}
              bondInsurance={bondInsurance}
              offers={offers}
              // Flag para indicar que é Segimob e precisa coletar dados do proprietário
              isSegimob={true}
            />
          )}
        </Modal.Content>
        <Modal.Actions>
          <Button color="red" onClick={() => setOpenHireProposalModal(false)}>
            <Icon name="remove" /> Sair
          </Button>
          <Button color="green" onClick={() => setFlagSubmitFrom(true)}>
            <Icon name="checkmark" /> Confirmar Contratação
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default SegimobHireProposalModal;
